import React, { useState ,useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch,FaUserCheck} from "react-icons/fa";
import { useLocation , useNavigate } from "react-router-dom";


function Rating({token}) {
  
  const location = useLocation();
const { dealer, given_to_type } = location.state;
     const navigate = useNavigate();
   const [searchTerm, setSearchTerm] = useState('');
  const[list,setList] = useState([]);
  const [showForm, setShowForm] = useState(false);

const fetchRatingHis = async () => {
  try {
    const res = await axios.get(
      `https://api.krimotion.in/fetch-rating/${dealer.id}?given_to_type=${given_to_type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setList(res.data);

  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchRatingHis();

  }, []);


     const filteredData = Array.isArray(list)
    ? list.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];


    const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; 
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
  return (
   <div className="container py-4">
     <div className="border-0  mb-3 px-2 py-2  ">
    
              <div className="d-flex flex-column gap-2">
    
                {/* TOP ROW: Title + Search */}
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
    
                  <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                    KM Score History
                  </h4>
    
                  <div style={{ flex: 1, maxWidth: "250px" }}>
                    <div
                      className="d-flex align-items-center rounded-pill overflow-hidden"
                      style={{
                        border: "1px solid var(--green)",
                        height: "34px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        backgroundColor: "white"
                      }}
                    >
                      <FaSearch style={{ color: "var(--green)", fontSize: "14px" }} />
    
                      <input
                        type="text"
                        className="form-control border-0 shadow-none"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          fontSize: "14px",
                          height: "32px",
                          marginLeft: "6px"
                        }}
                      />
                    </div>
                  </div>
    
                </div>
    
                {/* SECOND ROW: Back Button */}
                <div>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => navigate(-1)}
                  >
                    ← Back
                  </button>
                </div>
    
              </div>
    
    
            </div>

            
            <h5> 
              <span className="status-badge status-success px-3 py-2">
              {dealer.name}
              </span>
            </h5>
    
  

                             {!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (
          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center">

                <div>
                  <h5 className="fw-bold mb-1">
                    {dealer.given_by_name}
                  </h5>

                  <span className="badge bg-primary">
                    {dealer.given_by_type}
                  </span>
                </div>

                <div className="text-end">
                  <h4 className="text-warning mb-0">
                    ⭐ {Number(dealer.rate).toFixed(1)}
                  </h4>
                </div>

              </div>

              <hr />

              {/* Details */}

              <div className="inventory-row">
                <span className="inventory-label">
                  Enquiry No
                </span>

                <span>{dealer.enq_id}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Enquiry Type
                </span>

                <span>{dealer.enq_type}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Date
                </span>

                <span>{formatDate(dealer.date)}</span>
              </div>

          

              <div className="mt-3">
                <small className="text-muted fw-semibold">
                  Remark
                </small>

                <div
                  className="mt-1 p-2 rounded"
                  style={{
                    background: "#f8f9fa",
                    minHeight: "70px",
                  }}
                >
                  {dealer.remark || "No Remark"}
                </div>
              </div>

            </div>

          </div>
        ))
      ) : (
        <div className="col-12">
          <div className="alert alert-light text-center shadow-sm rounded-4">
            No KM Score Found
          </div>
        </div>
      )}

    </div>
  </div>
)}
   </div>
  )
}

export default Rating
